import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'repeating-events';

interface ICreateGroupEvent extends Omit<IUri, 'resource'> {
  body: Partial<IGroupEvent>;
  token: string;
}

interface ICreateGroupEventsResponse extends IHttpResponse {
  body?: IGroupEvent;
}

export default ({
  body,
  token,
}: ICreateGroupEvent): Promise<ICreateGroupEventsResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
  });

  return BaseService.Post({ url, token, data: body });
};
